export default "/kiban/_next/static/images/reflow-b61601aa3c2d3b1f5a16d5c326485978.png";